export default __webpack_public_path__ + "213fbe6b539bb9ca209a57f667437bcb.svg";